import { registerQuery } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
export const GET_FLAT_OBJECT_PROPERTIES = registerQuery({
  fieldName: 'flatProperties',
  args: ['objectTypeId'],
  fetcher({
    objectTypeId
  }) {
    return http.get(`properties/v4/${objectTypeId}`, {
      query: {
        includeFieldLevelPermission: true,
        includeProperties: true
      }
    });
  }
});
export const GET_OBJECT_PROPERTIES_FIELD_POLICY = {
  keyArgs: ['objectIds', 'objectTypeId', 'query', 'listId'],
  merge(existing, incoming) {
    if (!existing) {
      return incoming;
    }
    return Object.assign({}, incoming, {
      results: [...existing.results, ...incoming.results]
    });
  }
};
export const OBJECT_PROPERTIES_BY_OBJECT_FIELDNAME = 'allPropertiesByObject';
export const GET_ALL_OBJECT_PROPERTIES_BY_OBJECT = registerQuery({
  fieldName: OBJECT_PROPERTIES_BY_OBJECT_FIELDNAME,
  args: ['objectIds', 'objectTypeId', 'query', 'count', 'offset'],
  fetcher({
    objectIds,
    objectTypeId,
    query,
    count = 50,
    offset = 0
  }) {
    return http.post(`crm-search/search`, {
      data: {
        objectTypeId,
        count,
        offset,
        requestOptions: {
          allPropertiesFetchMode: 'latest_version',
          includeAllValues: true
        },
        // if object ids are provided, filter by those, otherwise this call gets all objects of a given objectType
        filterGroups: objectIds && [{
          filters: [{
            operator: 'IN',
            property: 'hs_object_id',
            values: objectIds
          }]
        }],
        query
      }
    });
  }
});
export const OBJECT_PROPERTIES_BY_LIST_FIELDNAME = 'allPropertiesByListId';
export const GET_ALL_OBJECT_PROPERTIES_BY_LIST_ID = registerQuery({
  fieldName: 'allPropertiesByListId',
  args: ['listId', 'objectTypeId', 'count', 'offset', 'query'],
  fetcher({
    listId,
    objectTypeId,
    query,
    count = 50,
    offset = 0
  }) {
    return http.post(`sales-views/v2/crm-search/with-placeholders`, {
      data: {
        objectTypeId,
        count,
        offset,
        requestOptions: {
          allPropertiesFetchMode: 'latest_version',
          includeAllValues: true
        },
        filterGroups: [{
          filters: [{
            operator: 'IN',
            property: 'ilsListMemberships.listId',
            values: [listId]
          }]
        }],
        query
      }
    });
  }
});